import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { type ReactNode } from "react";
import WaveDropTime from "../drops/time/WaveDropTime";
import { SingleWaveDropInfoAuthorSection } from "./SingleWaveDropInfoAuthorSection";
import { SingleWaveDropPosition } from "./SingleWaveDropPosition";
import { WinnerBadge } from "./WinnerBadge";
interface WaveDropMetaRowProps {
  readonly drop: ExtendedDrop;
  readonly isWinner: boolean;
  readonly mimeType?: string | undefined;
  readonly children?: ReactNode | undefined;
}
export const WaveDropMetaRow = t0 => {
  const $ = _c(21);
  const {
    drop,
    isWinner,
    mimeType,
    children
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = <SingleWaveDropInfoAuthorSection drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-text-white/40">{"\xB7"}</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== drop.created_at) {
    t3 = <WaveDropTime timestamp={drop.created_at} size="sm" />;
    $[3] = drop.created_at;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop.id || $[6] !== mimeType) {
    t4 = mimeType && <><span className="tw-text-white/40">{"\xB7"}</span><MediaTypeBadge mimeType={mimeType} dropId={drop.id} /></>;
    $[5] = drop.id;
    $[6] = mimeType;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== drop || $[9] !== isWinner) {
    t5 = isWinner && <><span className="tw-text-white/40">{"\xB7"}</span><WinnerBadge drop={drop} variant="simple" /></>;
    $[8] = drop;
    $[9] = isWinner;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== drop || $[12] !== isWinner) {
    t6 = !isWinner && drop?.drop_type === ApiDropType.Participatory && <><span className="tw-text-white/40">{"\xB7"}</span><SingleWaveDropPosition rank={drop.rank} drop={drop} variant="simple" /></>;
    $[11] = drop;
    $[12] = isWinner;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== children || $[15] !== t1 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">{t1}{t2}{t3}{t4}{t5}{t6}{children}</div>;
    $[14] = children;
    $[15] = t1;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};